import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { handleCreateFarmerAccountSubmit } from "../../api/registration";
import { Button } from "../common/Button";
import { FormLayout } from "../common/FormLayout";

export const ConfirmRegistrationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { formData, farmType } = location.state || {};
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setIsLoading(true);

    const response = await handleCreateFarmerAccountSubmit(formData);

    if (response.success) {
      setSuccess(response.message || "");
    } else {
      setError(response.error || "Une erreur est survenue");
    }

    setIsLoading(false);
  };

  if (success) {
    return (
      <FormLayout title="Inscription réussie">
        <div className="text-center space-y-6">
          <div className="text-secondary-text">
            <FontAwesomeIcon icon="check-circle" size="3x" />
          </div>

          <div className="inline-block bg-secondary-text p-6 rounded-lg">
            <p className="text-tertiary font-oxaniumMedium">{success}</p>
          </div>
        </div>
      </FormLayout>
    );
  }

  return (
    <FormLayout title="Confirmation de l'inscription">
      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <div className="space-y-8">
          <div>
            <h2 className="text-lg font-oxaniumMedium text-tertiary mb-4">
              Informations personnelles
            </h2>
            <div className="bg-white p-4 rounded-lg space-y-2">
              <p>
                <span className="font-medium">Nom :</span> {formData.nom}
              </p>
              <p>
                <span className="font-medium">Prénom :</span> {formData.prenom}
              </p>
              <p>
                <span className="font-medium">Email :</span> {formData.email}
              </p>
              <p>
                <span className="font-medium">Téléphone :</span>{" "}
                {formData.telephone}
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-lg font-oxaniumMedium text-tertiary mb-4">
              {t("confirm-company-info")}
            </h2>
            <div className="bg-white p-4 rounded-lg space-y-2">
              <p>
                <span className="font-medium">{t("company-name")} :</span>{" "}
                {formData.company.company_name}
              </p>
              <p>
                <span className="font-medium">{t("company-siret")} :</span>{" "}
                {formData.company.siret}
              </p>
              <p>
                <span className="font-medium">{t("company-address")} :</span>{" "}
                {formData.company.address}
              </p>
              {formData.company.address_complementary && (
                <p>
                  <span className="font-medium">
                    {t("company-address-complement")} :
                  </span>{" "}
                  {formData.company.address_complementary}
                </p>
              )}
              <p>
                <span className="font-medium">{t("company-postal")} :</span>{" "}
                {formData.company.zip_code}
              </p>
              <p>
                <span className="font-medium">{t("company-city")} :</span>{" "}
                {formData.company.city}
              </p>
              <p>
                <span className="font-medium">{t("company-country")} :</span>{" "}
                {formData.company.country}
              </p>
              <p>
                <span className="font-medium">
                  {t("company-phone-mobile")} :{" "}
                </span>
                {formData.company.phone_mobile}
              </p>
              <p>
                <span className="font-medium">
                  {t("company-phone-fixe")} :{" "}
                </span>
                {formData.company.phone_fixe}
              </p>
              <p>
                <span className="font-medium">{t("company-farm-type")} :</span>{" "}
                {farmType === "volaille"
                  ? t("farm-type-poultry")
                  : t("farm-type-pig")}
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-4">
          <Button
            type="button"
            variant="secondary"
            size="full"
            onClick={() => navigate(-1)}
            disabled={isLoading}
          >
            {t("button-modify")}
          </Button>
          <Button type="submit" size="full" disabled={isLoading}>
            {isLoading ? t("button-creating") : t("button-finish-registration")}
          </Button>
        </div>
      </form>
    </FormLayout>
  );
};
